import { Box, Grid, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import greenWave from "../../public/assets/images/home/more/career/greenWave.webp";
import blueWave from "../../public/assets/images/home/more/career/blueWave.webp";
import CloseIcon from "@mui/icons-material/Close";
import AnuprekshaThumb from "../../public/assets/images/home/more/career/AnuprekshaThumb.webp";
import Ankit from "../../public/assets/images/home/more/career/AnkitSirThumb.webp";
import RajatThumb from "../../public/assets/images/home/more/career/RajatThumb.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";

const videoTestimonial = [
  {
    src: "https://www.youtube.com/embed/T0mXtyuS8X0?autoplay=1",
  },
  {
    src: "https://www.youtube.com/embed/0F548gc1Xq4?autoplay=1",
  },
  {
    src: "https://www.youtube.com/embed/iqQJnQBN9hs?autoplay=1",
  },
];

const thumbnails = [
  { src: Ankit, alt: "Ankit" },
  { src: AnuprekshaThumb, alt: "Anupreksha" },
  { src: RajatThumb, alt: "Rajat" },
];

const sliderSettings = {
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: false,
  arrows: true,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
};

function Stories() {
  const [showVideo, setShowVideo] = useState(false);
  const [videoId, setVideoId] = useState(0);

  const playFunction = (id: number) => {
    setShowVideo(true);
    setVideoId(id);
  };

  const pauseFunction = () => {
    setShowVideo(false);
  };

  return (
    <Grid
      sx={{
        padding: "4%",
        position: "relative",
        display: "grid",
        margin: "auto",
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: { xs: "18px", md: "32px" },
          lineHeight: { xs: "24px", md: "40px" },
          textAlign: "center",
          margin: { xs: "20px 0", md: "20px 0 48px 0" },
        }}
      >
        Hear it from the{" "}
        <Box component="br" sx={{ display: { xs: "block", sm: "none" } }} />
        <span style={{ fontWeight: 700, fontSize: "40px" }}> team</span>
      </Typography>

      <Grid
        sx={{
          overflow: "hidden",
          width: { xs: "100%", md: "966px" },
          height: { xs: "280px", md: "543px" },
          margin: "auto",
        }}
      >
        <Slider {...sliderSettings}>
          {thumbnails.map((thumbnail, index) => (
            <Box
              key={thumbnail.alt}
              sx={{
                width: { xs: "100%", md: "966px" },
                height: { xs: "280px", md: "543px" },
                display: "flex !important",
                justifyContent: "center",
                alignItems: "center",
                margin: "0px 10px",
                cursor: "pointer",
              }}
              onClick={() => playFunction(index)}
            >
              <Image
                src={thumbnail.src}
                alt={thumbnail.alt}
                style={{ objectFit: "contain" }}
                loading="lazy"
              />
            </Box>
          ))}
        </Slider>
      </Grid>

      <Modal open={showVideo} onClose={pauseFunction}>
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#0A0C0F50",
          }}
        >
          <Box
            component="iframe"
            src={videoTestimonial[videoId].src}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sx={{
              width: "80%",
              height: { xs: "50%", md: "80%" },
              objectFit: "contain",
              border: 0,
            }}
          />
          <CloseIcon
            sx={{
              position: "absolute",
              top: "2%",
              right: "2%",
              color: "#bfbfbf",
              fontSize: "38px",
              zIndex: 100,
            }}
            onClick={pauseFunction}
          />
        </Box>
      </Modal>

      <Image
        src={greenWave}
        alt=""
        style={{
          position: "absolute",
          width: "100%",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          margin: "auto 0",
          zIndex: -1,
        }}
        loading="lazy"
      />
      <Image
        src={blueWave}
        alt=""
        style={{
          position: "absolute",
          width: "100%",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          margin: "auto 0",
          zIndex: -1,
        }}
        loading="lazy"
      />
    </Grid>
  );
}

export default Stories;
